import script from "./UTextStepper.vue?vue&type=script&setup=true&lang=ts"
export * from "./UTextStepper.vue?vue&type=script&setup=true&lang=ts"

import "./UTextStepper.vue?vue&type=style&index=0&id=4ba9ad88&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ba9ad88"]])

export default __exports__